import {JsonObject, JsonProperty} from 'json2typescript';

@JsonObject('DynamicData')
export class DynamicData {

    @JsonProperty('dataId',Number,true)
    dataId = 0;

    @JsonProperty('date_created',String,true)
    date_created = '';

    @JsonProperty('date_modified',String,true)
    date_modified = '';

    @JsonProperty('data_key',String,true)
    data_key = '';

    @JsonProperty('UEI',String,true)
    UEI = '';

    @JsonProperty('RespID',Number,true)
    RespID = 0;

    @JsonProperty('overwrite_key_values',Boolean,true)
    overwrite_key_values = false;

    @JsonProperty('data_values',[String],true)
    data_values:String[] = [];

    @JsonProperty('files_keys',[String],true)
    files_keys:String[] = [];
}
